import { useCallback, useRef } from 'react';
import { useResizeObserver } from '@tanium/react-use-resize-observer';
import { ListOverflowChangeEvent } from '../types/ListOverflowChangeEvent';

export const useListOverflow = (
  outerRef: React.RefObject<HTMLElement>,
  onListOverflowChange?: (e: ListOverflowChangeEvent) => void,
) => {
  const isListOverflowing = useRef<boolean>();

  return useResizeObserver(
    useCallback(
      ({ target }) => {
        if (outerRef.current && onListOverflowChange) {
          const newIsListOverflowing = target.clientHeight > outerRef.current.clientHeight;
          if (isListOverflowing.current !== newIsListOverflowing) {
            onListOverflowChange({ isListOverflowing: newIsListOverflowing });
            isListOverflowing.current = newIsListOverflowing;
          }
        }
      },
      [onListOverflowChange, outerRef],
    ),
  );
};
